import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { ICON_MAPPING } from '../../constants/icons';
import {
  getPackageServiceLabel,
  resolvePackageServiceGlyph,
} from 'legacyfrontend/views/paquete-detalle/components/package-preview/packageServiceIcons';
import { useTranslation } from 'react-i18next';
import 'styles/components/paquete-detalle.css';

const DEFAULT_INCLUDES = [
  { code: 'fa fa-plane', description: 'Vuelos' },
  { code: 'fa fa-bed', description: 'Hoteles' },
  { code: 'fa fa-car', description: 'Transporte' },
  { code: 'fa fa-medkit', description: 'Asistencia' }
];

const DynamicIncludesRow = ({ paquetesIncluidos, className, fullWidth = false, ...props }) => {
  const { t } = useTranslation('layout');
  const includesToShow = paquetesIncluidos?.length ? paquetesIncluidos : DEFAULT_INCLUDES;
  const isStringArray = typeof includesToShow[0] === 'string';
  const isInternalPage = window.location.pathname.includes(ROUTE_KEYS.PAQUETES);

  const isMobile = window.innerWidth <= 768;

  return (
    <div className={`package__includes__row ${className ?? ''}`} {...props} style={{ padding: isInternalPage ? '0' : '0.5rem 0.5rem 0.3rem 1rem' }}>
      {!isMobile && !isInternalPage && (
        <div className='package__includes__title mr-[1rem]'>Incluye</div>
      )}
      <div className='flex justify-around flex-1'>
        {includesToShow.map((included, index) => {
          let iconCode;
          let description;

          if (isStringArray) {
            iconCode = included;
            description = included;
          } else if (included.code) {
            iconCode = included.code;
            description = included.description;
          } else {
            iconCode = included.icon?.codigo;
            description = included.icon?.descripcion;
          }

          const iconRef = { codigo: iconCode, descripcion: description };
          const glyph = resolvePackageServiceGlyph(iconRef);
          const label =
            included.code && included.description
              ? included.description
              : getPackageServiceLabel(iconRef, t);
          const IconComponent = glyph.type === 'svg' ? null : ICON_MAPPING[iconCode];

          if (glyph.type !== 'svg' && !IconComponent) {
            return null;
          }

          return (
            <div
              className='package__includes__item'
              key={isStringArray ? index : included.id || `default-${index}`}
            >
              {glyph.type === 'svg' ? (
                <span
                  aria-hidden='true'
                  className='package__includes__icon package__includes__icon-glyph'
                  style={{ '--icon-url': `url(${glyph.src})` }}
                />
              ) : (
                <IconComponent className='package__includes__icon' />
              )}
              {label ? <span>{label}</span> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DynamicIncludesRow;
